import { useState, useEffect } from 'react'
import { Button, Modal, Spinner, Table } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { DownloadIcon } from '@enterprise-ui/icons'
import {
  COST_LOCATION_GROUP_TYPE,
  COST_SEARCH_VIEW_BY_OPTIONS,
} from '../globalConfig/constants'

export const ErrorSummaryModal = ({
  tableData,
  headerMetadata,
  rowHeader,
  isVisible,
  onClose,
  onDownload,
  isDownloadWaiting,
  headingText,
  subtext,
  scrollableWidth,
}) => {
  const [rowData, setRowData] = useState(null)
  const [columnDefs, setColumnDefs] = useState(null)

  useEffect(() => {
    if (isVisible && tableData) {
      buildTableData(tableData)
    } else {
      setRowData(null)
      setColumnDefs(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, tableData])

  const buildTableData = (data) => {
    const rowData = []
    const columnDefs = []
    const headerMetadataByVariableName = Object?.values(headerMetadata).reduce(
      (self, header) => ({ ...self, [header.variableName]: header }),
      {},
    )
    Object.keys(data?.[0]).forEach((rowDataVariable) => {
      if (headerMetadataByVariableName?.[rowDataVariable]) {
        columnDefs.push({
          field: rowDataVariable,
          headerName:
            Object.keys(headerMetadata).includes('COST_LOCATION_GROUP_VALUE') &&
            rowDataVariable ===
              headerMetadata?.COST_LOCATION_GROUP_VALUE?.variableName
              ? COST_SEARCH_VIEW_BY_OPTIONS?.[
                  data?.[0]?.[COST_LOCATION_GROUP_TYPE?.variableName]
                ]?.label
              : headerMetadataByVariableName?.[rowDataVariable]?.label,
          width:
            headerMetadataByVariableName?.[rowDataVariable]?.tableDetails
              ?.defaultColumnWidth,
          align:
            headerMetadataByVariableName?.[rowDataVariable]?.tableDetails
              ?.align,
          isRowHeader: rowHeader?.variableName === rowDataVariable,
        })
      }
    })
    const columnSortOrder = Object?.values(headerMetadata).reduce(
      (self, header) => [...self, header.variableName],
      [],
    )
    columnDefs.sort(function (a, b) {
      return columnSortOrder.indexOf(a.field) - columnSortOrder.indexOf(b.field)
    })

    data.forEach((rowObj) => {
      const displayRow = {}
      Object.keys(rowObj).forEach((fieldName) => {
        const fieldValue =
          rowObj[fieldName]?.constructor === Array
            ? rowObj[fieldName].join(', ')
            : rowObj[fieldName]
        displayRow[fieldName] = {
          cellValue: fieldValue,
          cellDisplay: (
            <div
              className={
                headerMetadataByVariableName?.[fieldName]
                  ? headerMetadataByVariableName?.[fieldName]?.tableDetails
                      ?.cellClassName
                  : null
              }
            >
              {headerMetadataByVariableName?.[fieldName]?.tableDetails
                ?.toStringFunc
                ? headerMetadataByVariableName?.[
                    fieldName
                  ]?.tableDetails?.toStringFunc(rowObj[fieldName])
                : fieldValue}
            </div>
          ),
        }
      })
      rowData.push(displayRow)
    })

    setRowData(rowData)
    setColumnDefs(columnDefs)
  }

  return (
    <Modal
      isVisible={isVisible}
      headingText={headingText || 'Error Summary'}
      onRefuse={() => onClose()}
      size="expanded"
    >
      {!tableData || !rowData || !columnDefs ? (
        <div className="hesp-general-flex hesp-general-justifyCenter hc-pa-normal">
          <Spinner size="expanded" />
        </div>
      ) : (
        <>
          <div className="hc-ph-normal hc-pb-normal">
            {onDownload || subtext ? (
              <div className="hesp-general-flex hesp-general-flex-direction-reverse hc-mb-normal">
                {onDownload && (
                  <Button
                    data-testid="es-download-button"
                    style={{
                      width: '150px',
                    }}
                    type="primary"
                    onClick={onDownload}
                    isLoading={isDownloadWaiting}
                  >
                    <>
                      <EnterpriseIcon
                        className="hc-mr-dense"
                        icon={DownloadIcon}
                      />
                      DOWNLOAD
                    </>
                  </Button>
                )}
                <div
                  className="hesp-general-fullwidth hesp-general-flex"
                  style={{ alignItems: 'center' }}
                >
                  <span>{subtext}</span>
                </div>
              </div>
            ) : null}
            <Table
              className="hesp-table-header"
              data-testid="es-table"
              name="Errors Table"
              id="errors-table"
              cellPadding="dense"
              alternateRowColor
              scrollableWidth={
                scrollableWidth !== undefined ? scrollableWidth : true
              }
              fixedHeader
              height={500}
              data={{
                defaultColDef: { sortable: false, resizable: true, width: 150 },
                columnDefs: columnDefs,
                rowData: rowData,
              }}
              roundCorner
            />
            <div className="hc-mt-normal hc-fs-md">
              {'Rows: '}
              <strong>{tableData?.length}</strong>
            </div>
          </div>
        </>
      )}
    </Modal>
  )
}
